import { useSelector } from 'react-redux';

import { getOrganizationCountry, resolveCountryCode } from '../../nationalId';
import { COUNTRIES, countriesFactory } from './constants';

const isoToCountryName = iso => {
  if (iso === 'CL') {
    return COUNTRIES.chile;
  }
  if (iso === 'AR') {
    return COUNTRIES.argentina;
  }
  if (iso === 'BR') {
    return COUNTRIES.brazil;
  }
  return COUNTRIES.default;
};

/**
 * Resolves form rules from an address/org country (ISO or display name).
 */
export const useRulesByCountry = ({ countryName } = {}) => {
  const organization = useSelector(state => state.organizations.organization)?.data || {};
  const rawCountry =
    countryName || getOrganizationCountry(organization) || COUNTRIES.default;
  const country = isoToCountryName(resolveCountryCode(rawCountry));

  const COUNTRY_FACTORY = countriesFactory(country);
  const countryRules = COUNTRY_FACTORY[country];
  const countryRulesForm = COUNTRY_FACTORY[country]?.form;

  const getRulesByCountry = pCountry => {
    const resolved = isoToCountryName(resolveCountryCode(pCountry));
    return countriesFactory(resolved);
  };

  return {
    country,
    countryRules,
    countryRulesForm,
    getRulesByCountry,
  };
};
